import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ContextService, Context, FullContext } from '@app/core/service/context.service';
import { ModalFactoryService } from '@app/core/ui/modal/modal-factory.service';
import { CompanyService } from '@app/core/business/company/company.service';
import { Observable } from 'rxjs';
import { Company } from '@app/core/business/company/company';
import { Customer } from '@app/core/business/customer/customer';
import { CustomerService } from '@app/core/business/customer/customer.service';
import { Order } from '@app/core/business/order/order';
import { OrderService } from '@app/core/business/order/order.service';
import { AuthenticationService } from '@app/core/business/user/authentication.service';
import { Router } from '@angular/router';
import { OrderStatus } from '@app/core/business/order/order-status';
import { PriceListType } from '@app/core/business/price-list-type.enum';
import { FrancoService } from '@app/core/business/franco/franco.service';
import { UserService } from '@app/core/business/user/user.service';
import { map } from 'rxjs/operators';
import { PlaytestService } from '@app/core/service/playtest.service';

@Component({
  selector: 'app-context-banner',
  templateUrl: './context-banner.component.html',
  styleUrls: ['./context-banner.component.scss'],
})
export class ContextBannerComponent implements OnInit {
  public context: Context = null;
  public fullContext: FullContext = null;
  @Input()
  public validityRate: number;
  @Input()
  public remainingTime: string;
  @Output()
  public reactivateOrderEmitter: EventEmitter<any>;

  @Input()
  public adresseLivraison: string = "Selectionnez une commande";

  public availableCompanies$: Observable<Company[]>;
  public availableCustomers$: Observable<Customer[]>;
  public availableOrders$: Observable<Order[]>;

  public availableCompanies: Company[];
  public availableCustomers: Customer[];
  public availableOrders: Order[];

  public loadingOrder = false;

  public orderStatus = OrderStatus;

  public usingDetailledPanel = false;




  public activePriceListType = PriceListType.Net;

  constructor(
    public contextService: ContextService,
    private userService: UserService,
    private orderService: OrderService,
    private companyService: CompanyService,
    private authenticationService: AuthenticationService,
    private customerService: CustomerService,
    private modalFactoryService: ModalFactoryService,
    public router: Router,
    // public playTestService: PlaytestService,
    private francoService: FrancoService
  ) {
    this.reactivateOrderEmitter = new EventEmitter<any>();

    this.contextService.context$.subscribe(context => {
      if (this.context !== context) {
        this.context = context;
        const userCode = this.userService.getUserFromLocalStorage();
        if (userCode && this.authenticationService.isLoggedIn()) {
          this.companyService.getAvailableCompanies$().subscribe(companies => {
            if (companies) {
              this.availableCompanies = companies;
            }
          });
        }
        if (context.companyCode && context.contactCode && this.availableCustomers$ == null) {
          this.availableCustomers$ = this.customerService.getCustomers(
            context.companyCode,
            context.contactCode
          );

          this.availableCustomers$.subscribe(customers => {
            customers = customers.filter(c => c.code !== context.customerCode);
            this.availableCustomers = customers;
          });
        }
      }
    });


    /** CLA le 13/02/2019 - récupération du type de prix
    const userCode = this.authenticationService.getUserCode();
    if (userCode) {
      this.userService.getUser(userCode).subscribe(user => {
        if (user.preferences.defaultPriceListType) {
          this.activePriceListType = user.preferences.defaultPriceListType;
        }
      });
    } */
  }

  public sendTriggerTabs() {
    // this.playTestService.countdown = 0;
    localStorage.setItem('token', 'fake-token-for-test');
    // this.playTestService.sendTriggerTabs();
  }

  ngOnInit() {
    this.userService.getUsingDetailledPanel$().subscribe(x => this.usingDetailledPanel = x);
    this.contextService.context$.subscribe((context) => this.context = context);
    this.contextService.fullContext$.subscribe((context) => this.fullContext = context);
  }

  public onOrderSelectorOpen() {
    this.loadingOrder = true;
    this.orderService
      .getOrders(this.context.companyCode, this.context.customerCode, true)
      .subscribe(orders => {
        orders = orders.filter(o => o.code !== this.context.orderCode);
        this.availableOrders = orders;

        this.loadingOrder = false;
      });
  }

  public onCompanySelected(companyCode: string) {
    this.contextService.setSelectedCompany(companyCode);
  }

  public onCustomerSelected(customerCode: string): void {
    const selectedCustomer = this.availableCustomers.filter(c => c.code === customerCode)[0];
    this.contextService.setSelectedCustomer(customerCode, selectedCustomer.codeClientKiwi, selectedCustomer.hasValidatedTerms);

    this.availableCustomers$.subscribe(customers => {
      customers = customers.filter(c => c.code !== this.context.customerCode);
      this.availableCustomers = customers;
    });
  }

  public async onOrderSelected(orderCode: string) {
    if (orderCode !== '') {
      this.onSelectOrderClick();
      await this.contextService.setSelectedOrder(orderCode);

      // URL actuelle
      const currentUrl = this.router.url;

      // Vérification si on est déjà sur la route '/offers'
      if (currentUrl.includes('offers')) {
        // Rechargement de la page
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate([currentUrl]);
        });
      } else {
        // Naviguation vers la route '/offers' normalement
        this.router.navigateByUrl('/offers');
      }
    } else {
      this.onNewOrder();
    }
  }

  public onSelectOrderClick() {
    this.contextService.resetSelectedOrder();
  }



  /**
   * CLA le 10/10/2019 - A/B - ajout du type de commande lors de la création d'une commande
   */
  public onNewOrder() {
    this.modalFactoryService.newOrder((order: Order) => {
      if (!order.orderType
        && this.fullContext.customer.orderTypes
        && this.fullContext.customer.orderTypes.length == 1)
        order.orderType = this.fullContext.customer.orderTypes[0].code;

      this.orderService
        .postNewOrder(
          this.context.companyCode,
          this.context.customerCode,
          order.customCode,
          order.deliveryAddress ? order.deliveryAddress.code : undefined,
          order.deliveryDate || undefined,
          order.headerComment,
          order.orderType,
        )
        .subscribe(o => {
          this.contextService.setSelectedFullOrder(o);
          this.router.navigateByUrl('/offers');
        });
    });
  }

  public displayOrderSelector() {
    this.modalFactoryService.orderSelector((orderCode: string) => {
      this.onOrderSelected(orderCode);
    });
  }
}
